{
    "name": "console",
    "version": "2026.9.0",
    "engines": {
        "node": ">=24",
        "npm": ">=10"
    },
    "private": true,
    "description": "Hellō Web Console SPA",
    "scripts": {
        "install:web": "cd web && npm i",
        "install:mock": "cd mock && npm i",
        "test": "cd web && npm run test:ci",
        "dev": "./scripts/dev.sh",
        "local": "./scripts/local.sh",
        "sso": "aws sso login --sso-session honestdinosaur",
        "review": "npm run rebase && npm run test && npm run pr"
    }
}
